<template>
  <DBox
    :id="'cmp-settings-local-details-settings'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_local_details_strings')}`"
    @add_click="onAddNewLocalDetailsClick"
  >
    <NTable
      v-if="localdetail_settings.length > 0"
      class="localdetail_settings-list h2 p0 dbox1"
      :headers="headers"
      :items="localdetail_settings"
      :config="tableConfig"
      :showNoItems="false"
      :style="{
        '--custom-fields-wdith': `${getCustomFieldListWidth()}px`,
      }"
      :id="'settings-bookings-local_details'"
      tdbdr="none"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('order_sequence')">
            <input
              type="text"
              class="ntable--textfield"
              name="order"
              :id="`order-${item.local_details_type_id}`"
              :placeholder="$t('order')"
              :value="item['sequence']"
              v-on:blur="(e) => onTextInputBlur(e, 'sequence', item)"
            />
          </td>
          <td v-bind="tdcon('local_details_type_name')">
            <input
              type="text"
              class="ntable--textfield"
              name="local_details_type_name"
              :id="`local_details_type_name-${item.local_details_type_id}`"
              :placeholder="$t('local_details_name')"
              :value="item['local_details_type_name']"
              :title="item['local_details_type_name']"
              v-on:blur="
                (e) => onTextInputBlur(e, 'local_details_type_name', item)
              "
            />
          </td>
          <td v-bind="tdcon('name')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="name"
                  :id="`name-${item.local_details_type_id}`"
                  :checked="getElement(item, 'name')"
                  @click="(e) => onCheckboxChange(e, 'name', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('address1')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="address1"
                  :id="`address1-${item.local_details_type_id}`"
                  :checked="getElement(item, 'address1')"
                  @click="(e) => onCheckboxChange(e, 'address1', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('city')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="city"
                  :id="`city-${item.local_details_type_id}`"
                  :checked="getElement(item, 'city')"
                  @click="(e) => onCheckboxChange(e, 'city', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('postalcode')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="postalcode"
                  :id="`postalcode-${item.local_details_type_id}`"
                  :checked="getElement(item, 'postalcode')"
                  @click="(e) => onCheckboxChange(e, 'postalcode', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('country')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="country"
                  :id="`country-${item.local_details_type_id}`"
                  :checked="getElement(item, 'country')"
                  @click="(e) => onCheckboxChange(e, 'country', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('phone')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="phone"
                  :id="`phone-${item.local_details_type_id}`"
                  :checked="getElement(item, 'phone')"
                  @click="(e) => onCheckboxChange(e, 'phone', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('mobile')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="mobile"
                  :id="`mobile-${item.local_details_type_id}`"
                  :checked="getElement(item, 'mobile')"
                  @click="(e) => onCheckboxChange(e, 'mobile', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('email')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="email"
                  :id="`email-${item.local_details_type_id}`"
                  :checked="getElement(item, 'email')"
                  @click="(e) => onCheckboxChange(e, 'email', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('url')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="url"
                  :id="`url-${item.local_details_type_id}`"
                  :checked="getElement(item, 'url')"
                  @click="(e) => onCheckboxChange(e, 'url', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('notes')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="notes"
                  :id="`notes-${item.local_details_type_id}`"
                  :checked="getElement(item, 'notes')"
                  @click="(e) => onCheckboxChange(e, 'notes', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('start_time')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="start_time"
                  :id="`start_time-${item.local_details_type_id}`"
                  :checked="getElement(item, 'start_time')"
                  @click="(e) => onCheckboxChange(e, 'start_time', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('end_time')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="end_time"
                  :id="`end_time-${item.local_details_type_id}`"
                  :checked="getElement(item, 'end_time')"
                  @click="(e) => onCheckboxChange(e, 'end_time', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('add_button')" style="align-items: center;">
            <div class="dt-icon-container">
              <img
                src="static/icons/add-icon.svg"
                class="dt-icon v5 s1"
                @click = "(e) => onAddLocalDetailsField(item)"
                :alt = "$t('add_local_details_field')"
                :title = "$t('add_local_details_field')"
              />
            </div>
          </td>
          <td v-bind="tdcon('custom')">
            <div class="custom-field-list ut-fc ut-w-full">
              <div
                class="ld-custom-field ut-w-full"
                :style="{
                  minHeight: `31px`,
                }"
                v-for="field of localDetailsFields(item.local_details_type_id)"
                :key="field.custom_field_id"
              >
                <input
                  type="text"
                  class="ntable--textfield"
                  name="custom_field"
                  :id="`custom_field-${field.custom_field_id}`"
                  :placeholder="$t('custom_field_name')"
                  :value="field['field_label']"
                  :title="field['field_label']"
                  v-on:blur="
                    (e) =>
                      onLocalDetailsFieldTextInputBlur(e, 'field_label', field)
                  "
                />
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    class="dt-icon v5 s1"
                    @click="(e) => onDeleteLDCustomField(field, item)"
                    :alt="$t('add_custom_field')"
                    :title="$t('add_custom_field')"
                  />
                </div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                v-if="isRemovableLocalDetailsType(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onDeleteLocalDetails(item)"
                :alt="$t('add_custom_field')"
                :title="$t('add_custom_field')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import {
  localDetailsExternalTable,
  isRemovableLocalDetailsType,
} from "../../models/local-details.mode";
import { createTableHeader } from "../../../../plugins/datatable";
import { sortLocalDetailsFields } from '../../../booking/models/local-details.model';

export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    bookingSettingsData: {
      type: Object,
      default: () => [],
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        // rowHeight: 32,
        fullHeight: true,
        rowHeight: "auto",
        // footer: false
      }),
    };
  },
  computed: {
    // headers: function() {
    //   return [
    //     { text: this.$t("Order"), value: "Order" },
    //     { text: this.$t(""), value: "local_details_type_name" },
    //     { text: this.$t("Name"), value: "name" },
    //     { text: this.$t("Address1"), value: "address1" },
    //     { text: this.$t("City"), value: "city" },
    //     { text: this.$t("PostalCode"), value: "postalcode" },
    //     { text: this.$t("Country"), value: "country" },
    //     { text: this.$t("Phone"), value: "phone" },
    //     { text: this.$t("Mobile"), value: "mobile" },
    //     { text: this.$t("Email"), value: "email" },
    //     { text: this.$t("Url"), value: "url" },
    //     { text: this.$t("Notes"), value: "notes" },
    //     { text: this.$t("StartTime"), value: "start_time" },
    //     { text: this.$t("EndTime"), value: "end_time" },
    //     { text: this.$t(""), value: "add_button" },
    //     { text: this.$t("Custom"), value: "custom" },
    //     { text: this.$t(""), value: "options" },
    //   ];
    // },text: this.$t('postalcode')

    headers: function () {
      return [
        createTableHeader("order_sequence", { mw: 50 }),
        createTableHeader("local_details_type_name", {
          text: "local_details",
          f: 3,
        }),
        createTableHeader("name", { mw: 80, ta: "center" }),
        createTableHeader("address1", { mw: 80, ta: "center" }),
        createTableHeader("city", { mw: 80, ta: "center" }),
        createTableHeader("postalcode", {
          text: "postalcode",
          ta: "center",
          mw: 80,
        }),
        createTableHeader("country", { mw: 80, ta: "center" }),
        createTableHeader("phone", { mw: 80, ta: "center" }),
        createTableHeader("mobile", { mw: 80, ta: "center" }),
        createTableHeader("email", { mw: 80, ta: "center" }),
        createTableHeader("url", { mw: 80, ta: "center" }),
        createTableHeader("notes", { mw: 80, ta: "center" }),
        // createTableHeader("email", {ta: "center"}),
        createTableHeader("start_time", { mw: 80, ta: "center" }),
        createTableHeader("end_time", { mw: 80, ta: "center" }),
        createTableHeader("add_button", { text: false, mw: 80, ta: 'center' }),
        createTableHeader("custom", { minw: 220, mw: 300, f: 3 }),
        createTableHeader("options", { mw: 30, text: false }),
      ];
    },

    localdetail_settings: function () {
      return (
        this.bookingSettingsData?.booking_localdetail_settings?.sort(
          (a, b) => a.sequence - b.sequence
        ) || []
      );
    },
  },
  methods: {
    onAddNewLocalDetailsClick: function () {
      this.$emit("add_click", true);
    },
    isRemovableLocalDetailsType: isRemovableLocalDetailsType,
    onCheckboxChange: function (event, name, item) {
      const value = event.target.checked;
      let elements = item.local_details_elements?.split(",") || [];

      if (value) {
        if (!elements.includes(name)) {
          elements = [...elements, name];
        }
      } else {
          elements = elements.filter((el) => el != name);        
      }
      elements = elements.filter((el) => el != "");   

      //Sort by default fields sequence
      // elements = elements.sort((a, b) => this.fields.indexOf(a) - this.fields.indexOf(b));

      // console.log({
      //   value: elements.join(","),
      //   name: "local_details_elements",
      //   item,
      // });

      this.$emit("ldt_changed", {
        value: sortLocalDetailsFields(elements).join(","),
        name: "local_details_elements",
        item,
      });
    },
    onTextInputBlur: function (event, name, item) {
      this.$emit("ldt_changed", {
        value: event.target.value,
        name,
        item,
      });
    },
    onDeleteLocalDetails: function (item) {
      this.$emit("delete", item);
    },
    getConf: function (name, key) {
      // console.log(name, key);
      return this.conf && this.conf[key] && this.conf[key][name] == 1
        ? true
        : false;
    },
    getMandatory: function (item) {
      const key = item.key ? item.key : item.local_details_type_id;
      return this.getConf("mandatory", key);
    },
    getQuestion: function (item) {
      const key = item.key ? item.key : item.local_details_type_id;
      return this.getConf("question", key);
    },
    getRequest: function (item) {
      const key = item.key ? item.key : item.local_details_type_id;
      return this.getConf("request", key);
    },
    getElement: function (item, key) {
      return item.local_details_elements?.split(",").includes(key);
    },
    localDetailsFields: function (local_details_type_id) {
      return (
        this.bookingSettingsData[`local_details_${local_details_type_id}`] || []
      );
    },
    onDeleteLDCustomField: function (
      { custom_field_id },
      { local_details_type_id }
    ) {
      this.$emit("ld_field_deleted", {
        custom_field_id,
        external_table: localDetailsExternalTable(local_details_type_id),
      });
    },
    getCustomFieldListWidth: function () {
      return (
        Math.max(
          ...this.localdetail_settings
            .map((e) => e.local_details_type_id)
            .map((id) => this.bookingSettingsData[`local_details_${id}`])
            .map((fields) => fields.length)
        ) * 100
      );
    },
    onAddLocalDetailsField: function ({ local_details_type_id }) {
      openModalRoute(this, "add_local_details_field", {
        local_details_type_id,
      });
    },
    onLocalDetailsFieldTextInputBlur: function (event, name, item) {
      this.$emit("ld_field_changed", {
        value: event.target.value,
        item,
        name,
      });
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-local-details-settings {
  .dt-ntable {
    // --ntable-th-padding: 0px !important;
    --ntable-text-align: center;
    --custom-fields-wdith: 100px;
    table-layout: auto;

    th {
      height: 31px;
      text-overflow: ellipsis;
      word-break: break-all;

      overflow: hidden;
      white-space: nowrap;
    }

    td:not(.custom) {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: revert-layer;
      align-content: flex-start;
      height: 31px;
    }

    td {
      > span,
      > div {
        margin: 0 !important;
      }
    }
    td.custom {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .ld-custom-field {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        // max-width: 100px;
        margin: 0 3px !important;

        background: hsla(0, 0%, 92%, 0.2);

        &:not(:last-child) {
          &:not(:first-child) {
            height: 32px;
          }
          input {
            &:not(:hover) {
              border-bottom: 1px solid var(--sprt-85);
            }
          }
        }

        input {
          // max-width: 45px;
          flex: 1;
          height: auto !important;
          text-overflow: ellipsis;
          padding: 0 3px !important;
          margin-right: 0;
        }
      }
    }
    .ntable--textfield {
      min-width: 0;
      background-color: var(--fc2-bc);
      color: var(--text-primary);
      border: 1px solid transparent;
      outline: none;
      padding: 0px 5px;
      margin: 3px 3px 3px 0;
      resize: none;
      border-radius: 4px;
      box-sizing: border-box;
      transition: margin 50ms ease-in-out, padding 50ms ease-in-out,
        border-radius 50ms ease-in-out;

      &:hover {
        outline: none;
        border: 1px solid var(--bc-cblue5);
      }

      &:focus,
      &:active {
        border-color: var(--fc2-bc);
        border-right-color: var(--cornblue);
        border-left-color: var(--cornblue);
        outline: none;
        background: var(--fc2-bc);
        margin: -1px 0;
        border-radius: 0;
        transition: margin 50ms ease-in-out, padding 50ms ease-in-out,
          border-radius 50ms ease-in-out;
      }
    }
  }
}
</style>
